import axios from "axios";

const Agent = () => {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;

  const responseBody = (response) => response.data;
  const responsePostBody = (response) => {
    return response;
  };
  const errorBody = (error) => {
    console.log(error);
    throw error.response;
  };
  const requests = {
    getFile: (url, attribute, token) =>
      axios
        .get(url, {
          params: attribute,
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
          },
          responseType: "blob",
        })
        .then(responsePostBody),
    getAtt: (url, attribute, token, shopId) =>
      axios
        .get(url, {
          params: attribute,
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
          },
        })
        .then(responseBody),
    get: (url, token, shopId) =>
      axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
          },
        })
        .then(responseBody),
    publicPost: (url, body) =>
      axios
        .post(url, body, {
          headers: {
            "Content-type": "application/json",
            "X-App-Platform": "Staff", // or "Customer", "Admin"
            Accept: "application/json",
          },
          withCredentials: true,
        })
        .then(responseBody)
        .catch(errorBody),
    post: (url, body, token, shopId) =>
      axios
        .post(url, body, {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
          },
        })
        .then(responsePostBody)
        .catch(errorBody),
    putForm: async (url, file, token, shopId) => {
      let formData = new FormData();
      formData.append("File", file);

      return axios
        .put(url, file, {
          headers: {
            "Content-type": "multipart/form-data",
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
          },
        })
        .then(responsePostBody)
        .catch(errorBody);
    },
    put: (url, body, token, shopId) =>
      axios
        .put(url, body, {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
          },
        })
        .then(responsePostBody)
        .catch(errorBody),
    delWithBody: (url, body, token) => {
      axios
        .delete(url, {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
          },
          params: body,
        })
        .then(responseBody)
        .catch(errorBody);
    },
    del: (url, token, shopId) =>
      axios
        .delete(url, {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
          },
        })
        .then(responseBody)
        .catch(errorBody),
    postForm: (url, file, token, shopId) => {
      let formData = new FormData();
      formData.append("File", file);
      return axios
        .post(url, file, {
          headers: {
            "Content-type": "multipart/form-data",
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "X-Active-ShopId": shopId,
          },
          validateStatus: (status) => status >= 200 && status < 300,
        })
        .then(responsePostBody)
        .catch(errorBody);
    },
  };
  return {
    requests,
  };
};
export default Agent;
